import React, { useEffect, useState } from "react";
import Pagination from "../../Components/Pagination/Pagination";

import { useRef } from "react";
import "./loaderstyle.css";
import LocalLoader from "../../Components/Loader/LocalLoader";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { checkTransactionStatus, getTransactionList, refundAddmoneyTransaction, searchUser } from "../../utils/api";
import { FilterWrapper } from "../../assets/styles/FilterStyle";
import DatePicker from "react-datepicker";
import {
  getDateFromDateObj,
  isEmpty,
} from "../../utils/common";
import { TableWrapper } from "../../Components/styledConstant";
import { useLocation, useNavigate } from "react-router-dom";
import raiseTicket from "../../assets/images/raise_ticket.svg";
import AsideLeft from "../../Components/AsideLeft/AsideLeft";
import { useSelector } from "react-redux";
import { AlertWrapper } from "../../Components/Modal/style";
import MoreOptions from "../../Components/MoreOptions/MoreOptions";
import ConfirmBox from "../../Components/ConfirmBox/ConfirmBox";
import DateRangePicker from "../../Components/DateRangePicker/DateRangePicker";
import AsideLeft_V2 from "../../Components/AsideLeft/AsideLeft_V2";
require("react-datepicker/dist/react-datepicker.css");




const  serviceType_= [
  {
   label:"Prepaid Recharge",
   value:"PREPAID_RECHARGE",
  },
  {
   label:"AEPS",
   value:"AEPS",
  },
  {
   label:"Aadhar Pay",
   value:"AADHAAR_PAY",
  },
  {
   label:"Send Money",
   value:"SEND_MONEY",
  },
  {
   label:"Settlement",
   value:"SETTLEMENT",
  },
  {
   label:"BBPS",
   value:"BBPS",
  },
  {
   label:"Payout",
   value:"PAY_OUT",
  },
  {
   label:"Add Money",
   value:"PAYMENT_GATEWAY",
  },
  {
   label:"UPI Pay",
   value:"UPI_PAY",
  },
  {
    label:"IRCTC",
    value:"IRCTC",
   },
  {
   label:"POS",
   value:"POS",
  },
  
  {
   label:"CDM",
   value:"CDM",
  },
  {
   label:"DQR",
   value:"DQR",
  },
  {
   label:"Virtual Account",
   value:"VIRTUAL_ACCOUNT",
  },
  {
   label:"Hotel",
   value:"HOTEL",
  },
  {
   label:"Flight",
   value:"FLIGHT",
  },
  {
   label:"Bus",
   value:"BUS",
  },
 
]



const TransactionTable = () => {
  const [transactions, setTransactions] = useState([]);
  const [totalPages, setTotalPages] = useState(null);
  const [totalElements, setTotalElements] = useState("");
  const [currPage, setCurrPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [fromDate, setStartDate] = useState("");
  const [toDate, setEndDate] = useState("");
  const [service, setService] = useState("");
  const [msgError, setMsgError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfData, setPdfData] = useState([]);
  const [selectOperator, setSelectOperator] = useState("");
  const [selectStatus, setSelectStatus] = useState("");
  const [selectType, setSelectType] = useState("Select");
  const [selectMode, setSelectMode] = useState("Select");
  const [transactionId, settransactionId] = useState("");
  const [userName, setUserName] = useState("");
  const [userUuid, setUserUuid] = useState("");
  const [refTransactionId, setREfTransactionId] = useState("");
  const link = useRef();
  const [downloadLoader, setDownloadLoader] = useState("");
  const [showfilter, setShowFilter] = useState("");
  const [checkStatusMsg, setCheckStatusMsg] = useState({});
  const [payoutData, setPayoutData] = useState({});
  const [accountHolderName, setAccountHolderName] = useState("");
  const [refundData, setRefundData] = useState(null);
  const [txnLoading, setTxnLoading] = useState(null);
     const [message, setMessage] = useState(null);
       const [msg, setMsg] = useState({});
       const [settlement, setSettlement]= useState(null)

  const navigate = useNavigate();

  const [payBox, setPayBox] = useState(false);


  const{ user } = useSelector((state) =>state.user);

  const clearRef = useRef(null);
  const clearDate = (callback) => {
    if (clearRef.current) return;
    clearRef.current = callback;
  };

  const constChangeDate = (startDate, endDate) => {
    if (endDate) {
      setEndDate(endDate);
      setStartDate(startDate);
    }
  };

  const onClearDate = () => {
    setEndDate("");
    setStartDate("");
  };


  const travelService = ["HOTEL","FLIGHT","BUS"];
  // Date Format
  var currentDate = new Date();
  var formattedDate = [
    currentDate.getDate(),
    currentDate.getMonth() + 1,
    currentDate.getFullYear(),
  ]
    .map((n) => (n < 10 ? `0${n}` : `${n}`))
    .join("-");

  const numberReg = /^[0-9]+$/;
  const findUserName = (e) => {
    const value = e.target.value;
    setUserUuid("")
    if (!numberReg.test(value) && value) {
      return;
    } else {
      setUserName(value);
      if (value.length === 10) {
        searchUser(value).then((resp) => {
          if (resp?.data?.success) {
            setUserUuid(resp?.data?.data?.uuid);
          } else {
            setUserUuid("sxnsb");
          }
        });
      }
    }
  };

  const handleCreateTicket = (userId) => {
    navigate("/createticket",{ state:userId});
  };
  const transactionData = (key = "") => {
    let _fromdate = getDateFromDateObj(fromDate, "YYYY-MM-DD");
    let _todate = getDateFromDateObj(toDate, "YYYY-MM-DD");

    if (
      getDateFromDateObj(fromDate, "YYYY-MM-DD") === "Invalid date" ||
      getDateFromDateObj(toDate, "YYYY-MM-DD") === "Invalid date"
    ) {
      _fromdate = "";
      _todate = "";
    }



 
    let param = {
      fromDate: _fromdate,
      toDate: _todate,
      pagination: {
        pageNo: currPage,
        pageSize: pageSize,
      },
      userUuid: userUuid,
      serviceType: selectOperator,
      transactionId: transactionId,
      status: selectStatus,
      refTransactionId: refTransactionId,
      route:"",
      accountHolderName: accountHolderName || undefined,
    };
    if(travelService.includes(selectOperator)){
      param.serviceType = "TRAVEL";
      param.route = selectOperator;
    }


    if (key === "CSV" || key === "PDF") {
       if (
              getDateFromDateObj(fromDate, "YYYY-MM-DD") === "Invalid date" ||
              getDateFromDateObj(toDate, "YYYY-MM-DD") === "Invalid date"
            ) {
              setMsg({
                msg: "Please select a date range of up to 31 days to download the report.",
                type: "error",
              });
      
              return;
            } else {
              const fromD = getDateFromDateObj(fromDate, "YYYY-MM-DD");
              const toD = getDateFromDateObj(toDate, "YYYY-MM-DD");
              const date1 = new Date(fromD);
              const date2 = new Date(toD);
              const differenceMs = Math.abs(date2 - date1);
      
              const differenceDays = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));
      
             if (differenceDays > 31) {
        setMsg({
          msg: `Selected range: ${differenceDays} days. Maximum allowed is 31 days.`,
          type: "error",
        });
        return;
      }
            }
      if (key === "CSV") {
        setDownloadLoader("CSV");
      } else {
        setDownloadLoader("PDF");
      }
      param.pagination.pageSize = totalElements;
      param.pagination.pageNo = 0;
      setCurrPage(0);
      // param.serviceType = ""
    }else{
         setLoading(true);
    }
    if (key === "search" || key === "refreshData") {
      param.pagination.pageNo = 0;
      setCurrPage(0);
    } else {
      setLoading(true);
    }
    if (key === "refresh") {
      dataRefresh();
      param.fromDate = "";
      param.serviceType = "";
      param.transactionId = "";
      param.toDate = "";
      param.userName = "";
      param.refTransactionId = "";
      param.userUuid = "";
      param.pagination.pageNo = 0;
      setCurrPage(0);
    }
    getTransactionList(param).then((resp) => {
      setLoading(false);
      setDownloadLoader("");
      if (resp?.data?.success) {
        if (key == "CSV") {
          setPdfData(resp?.data?.data?.content);
          setTimeout(() => {
            const csvlink = link.current;
            csvlink.link.click();
          }, 100);
        } else if (key === "PDF") {
          transactionPdfData(resp?.data?.data?.content);
        } else {
          setTransactions(resp?.data?.data?.content);
          setTotalPages(resp?.data?.data?.totalPages);
          setTotalElements(resp?.data?.data?.totalElements);
          // setCurrPage(resp?.data?.data?.number)
        }
      } else {
        setTransactions([]);

        setTotalPages(null);

        if (resp?.data?.errorCodeList.length < 1) {
          setMsgError(resp?.data?.msg);
        } else {
          setMsgError(resp?.data?.errorCodeList[0]);
        }
      }
    });
  };

  const location = useLocation();
  const serviceType = location.state;

  useEffect(()=>{
    if (!isEmpty(serviceType)) {
      setSelectOperator(serviceType?.type);
    } else {
      setSelectOperator("UPI_PAY");
    }
  },[serviceType])

  useEffect(() => {
    if (!isEmpty(selectOperator)) {
      transactionData();
    } 
  }, [ selectOperator, currPage, selectStatus]);

  const handleOpertaorChange = (e) => {
    setStartDate("");
    setEndDate("");
    setSelectOperator(e.target.value);
    setCurrPage(0);
  };
  const dataRefresh = () => {
    setSelectOperator("");
    settransactionId("");
    setREfTransactionId("");
    setSelectStatus("");
    setSelectType("Select");
    setSelectMode("");
    setService("");
    setStartDate("");
    setEndDate("");
    setUserUuid("");
    setUserName("");
    setAccountHolderName("");
     if(clearRef.current){
   
    clearRef.current();
  }
  };

  const transactionPdfData = (data = []) => {
    let _width = 400; // Width of the custom size
    const height = 297;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm", // units: mm, cm, in, px
      format: [_width, height],
      compress: true,
      putOnlyUsedFonts: true,
      precision: 16, // n
    });



    //Add fileName in the center
    const text = "Transaction List";
    // Calculate the width of the text
    const textWidth =
      (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;
    // Get the width of the PDF
    const pdfWidth = doc.internal.pageSize.width;
    const yPos1 = 10;
    // Calculate the X position for center alignment
    const centerXPos = (pdfWidth - textWidth) / 2;
    doc.text(text, centerXPos, yPos1);

    // Calculate the width of the date text
    const dateWidth =
      (doc.getStringUnitWidth(formattedDate) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;

    // Calculate the X position for right alignment
    const rightXPos = pdfWidth - dateWidth - 15; // 10 is for some margin from the right edge
    doc.text(formattedDate, rightXPos, yPos1);

    // Create a table from API data
    const tableData = [];

    data.forEach((item, index) => {
      const dateTimeString = item.transactionDate;
      let [date, time] = dateTimeString.split("T");
      let newTime = time.slice(0, 8);
      const rowData = [
        index + 1,
        item.userFullName,
        item.userPhoneNumber,
        item.serviceType === "PREPAID_RECHARGE"
          ? item.rechargedNumber
          : item.serviceType === "AEPS"
          ? item.serviceType
          : item.serviceType === "SEND_MONEY"
          ? item.accountHolderName
          : item.serviceType === "BBPS"
          ? item.accountNumber
          : item.rechargedNumber,
        item.serviceType === "PREPAID_RECHARGE"
          ? item.operatorCode
          : item.serviceType === "DTH"
          ? item.operatorCode
          : item.serviceType === "AEPS"
          ? item.orderId
          : item.refTransactionId,
        item.serviceType === "PREPAID_RECHARGE"
          ? item.transactionId
          : item.serviceType === "DTH"
          ? item.transactionId
          : item.serviceType === "AEPS"
          ? item.transactionId
          : item === "SEND_MONEY" || item === "BBPS"
          ? item.transactionId
          : item.accountIfscCode,
        date + " " + newTime,
        item?.amount,
        item?.status,
        item?.serviceType,
        item?.route,
      ]; // Customize as needed
      tableData.push(rowData);
    });
    doc.autoTable({
      head: [
        [
          "S.No",
          "Retailer Name",
          "Retailer No.",
          selectOperator === "PREPAID_RECHARGE"
            ? "Recharge Number"
            : selectOperator === "AEPS"
            ? "Service Type"
            : "Account Number",

          selectOperator === "PREPAID_RECHARGE"
            ? "Operator Code"
            : selectOperator === "DTH"
            ? "Operator Code"
            :  "Ref. TransactionId",
          selectOperator === "PREPAID_RECHARGE"
            ? "Transaction Id"
            : selectOperator === "DTH"
            ? "Transaction Id"
            : selectOperator === "AEPS"
            ? "Merchant Transaction Id"
            : selectOperator === "SEND_MONEY" || selectOperator === "BBPS"
            ? "Transaction Id"
            : "Account IFSC Code",
          "Created Date",
          "Amount",
                   
          "Status",
          "Service Type",
          "Route",
        ],
      ], // Customize table header
      body: tableData,
    });

  const fromD = getDateFromDateObj(fromDate, "YYYY-MM-DD");
const toD = getDateFromDateObj(toDate, "YYYY-MM-DD");

// current timestamp (safe for filenames)
const currentTimeMs = Date.now();


const fileName = `Transaction_${selectOperator}_${fromD}_to_${toD}_${currentTimeMs}.pdf`;

doc.save(fileName);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      transactionData();
    }
  };

  const changeStatus = (e) => {
    setSelectStatus(e.target.value);
    setCurrPage(0);
 
  };

  const navigationDaital = (item) => {
    navigate(`/transactions/${item?.transactionId}`, { state: { detail: item,type:"Transaction"} });
  };



  const checkStatus = (transactionId) => {
    const param = {
      transactionId:transactionId
    }
    checkTransactionStatus(param).then((resp) =>{
    
      if(resp?.data?.success){
        setCheckStatusMsg({msg:resp?.data?.msg,type:"success"});
        transactionData();
      }else{
           let msg = ""
           if(resp?.data?.errorCodeList.length > 0){
            msg = resp?.data?.errorCodeList[0]
           }else{
           msg = resp?.data?.msg;
           }
           setCheckStatusMsg({msg:msg,type:"error"});
           
      }

    })
  };

useEffect(() =>{
  setTimeout(() =>{
    setCheckStatusMsg({})
  },5000);
},[]);

useEffect(() =>{
  setTimeout(() =>{
    setCheckStatusMsg({})
  },5000);
},[]);
console.log("selectOperator",selectOperator)

const handlePayout = (item) =>{
  setPayoutData(item)
  setPayBox(true);
}

const closeSidebar = () =>{
  setPayoutData({})
  setSelectOperator("PAY_OUT")
  setPayBox(false);
}

  const moreOptions = [

    {
      label:"View Invoice",
      show:(item)=> true,
      click:(item)=>navigationDaital(item),
    },
    {
      label:"Raise ticket",
      show:(item)=>true,
      click:(item)=>handleCreateTicket(item),
    },
    {
      label:"Payment Refund",
      show:(item)=>false,
      click:(item)=>setRefundData(item),
    },
    {
      label:"View Logs",
      show:(item)=>user?.userType === "ROLE_ADMIN",
      click:(item)=>    navigate(`/transaction/logs`, { state: { detail: item,type:"Transaction"} }),
    },
    // {
    //   label:"Settlement",
    //   show:(item)=>item?.serviceType === "POS" && !item?.isSettlementComplete && user?.userType === "ROLE_ADMIN",
    //   click:(item)=>setSettlement(item),
    // },
  ]
  const RefundTransaction = (item) => {
    const payload = {
     txnId : item?.txnId,
  }

  setTxnLoading(true)
  refundAddmoneyTransaction(payload).then((resp) =>{
    setTxnLoading(false);
    setRefundData(null);
    if(resp?.data?.success){
      setMessage({ msg: resp?.data?.msg, type: "success" });
      
     transactionData();
    }else{
      let msg = "";
            if (resp?.data?.errorCodeList.length > 0) {
              msg = resp?.data?.errorCodeList[0];
            } else {
              msg = resp?.data?.msg;
            }
            setMessage({ msg: msg, type: "error" });
    }
  }).catch((err) =>{
    setRefundData(null);
  });
  
    }

    const fromD = getDateFromDateObj(fromDate, "YYYY-MM-DD");
const toD = getDateFromDateObj(toDate, "YYYY-MM-DD");

// current timestamp (safe for filenames)
const currentTimeMs = Date.now();


const fileName = `Transaction_${selectOperator}_${fromD}_to_${toD}_${currentTimeMs}.csv`;

  return (
    <div className="transactions_container">
       {!isEmpty(msg) && (
              <AlertWrapper className={`${msg.type} globle`}>
                <span className="close" onClick={() => setMsg({})}>
                  ×
                </span>
                {msg.msg}
              </AlertWrapper>
            )}
    <div style={{ padding: "30px" }}>
      <div
        className="transaction_main_container"
        style={{ marginTop: "-10px" }}
      >
        <div className="userlist_head">
          <div className="userlist_heading">
            <div className="userlist_left">
              <label>Transactions</label>
            </div>
            <div className="userlist_right">
           {((user?.userName === "8800578866") || (user?.userName === "8699466675")) && <button
            style={{marginRight:"8px"}}
                  className="pdf"
                  onClick={(e) => setPayBox(true)}
                >
                  Payout
                </button> }
              {downloadLoader !== "PDF" ? (
                <button className="pdf" onClick={() => transactionData("PDF")}>
                  PDF
                </button>
              ) : (
                <button className="pdf">
                  <div className="btn-loader">
                    <i className="fa-solid fa-spinner"></i>
                  </div>
                </button>
              )}

              {downloadLoader !== "CSV" ? (
                <button className="xls" onClick={() => transactionData("CSV")}>
                  CSV
                </button>
              ) : (
                <button className="xls">
                  <div className="btn-loader">
                    <i className="fa-solid fa-spinner"></i>
                  </div>
                </button>
              )}
              <CSVLink
                ref={link}
                data={pdfData}
                filename={fileName}
              ></CSVLink>
            </div>
            <div className="userlist_filter">
              <button
                className="filter fs-16"
                onClick={(e) =>
                  showfilter === "active"
                    ? setShowFilter("")
                    : setShowFilter("active")
                }
              >
                <i className="fa-solid fa-filter"></i>
              </button>
            </div>
          </div>
        </div>

        <FilterWrapper
          style={{ height: "auto" }}
          className={`display_data ${showfilter}`}
        >
          <div className="filterBox">
            <div>
              <div className="flex align-items gap-15">
                <div className="input-field">
                  <select
                    className="input_select_field"
                    value={selectOperator}
                    onChange={handleOpertaorChange}
                  >
                  {
                    serviceType_.map((value,i) =>{
                      return(<option key={i} value={value.value}>{value.label}</option>)
                    })
                  }
                   
                  </select>
                </div>
               
                <div className="input-field">
                  <select
                    className="input_select_field"
                    value={selectStatus}
                    onChange={(e) => changeStatus(e)}
                  >
                    <option value={""}>Select Status</option>
                    <option value="SUCCESS">Success</option>
                    <option value="FAIL">Fail</option>
                    <option value="INITIATED">Pending</option>
                  </select>
                </div>

                <div className="">
                  <input
                    type="text"
                    name="userName"
                    placeholder="Mobile Number"
                    value={userName}
                    maxLength={10}
                    onChange={findUserName}
                    onKeyDown={handleKeyDown}
                  ></input>
                </div>

          
                                    <DateRangePicker applyDate={constChangeDate} defaultDate={null} 
onClear={onClearDate}
 clearDate={clearDate} 
/>

                <div className="">
                  <input
                    type="text"
                    name="refTransactionId"
                    placeholder="Ref Transaction Id"
                    value={refTransactionId}
                    onChange={(e) => setREfTransactionId(e.target.value)}
                    onKeyDown={handleKeyDown}
                  ></input>
                </div>
                {selectOperator === "PAY_OUT" && <div className="">
                  <input
                    type="text"
                    name="accountHolderName"
                    placeholder="Account Holder Name"
                    value={accountHolderName}
                    onChange={(e) => setAccountHolderName(e.target.value)}
                    onKeyDown={handleKeyDown}
                  ></input>
                </div>}
                <div className="">
                  <input
                    type="text"
                    name="transactionId"
                    placeholder="Transaction Id"
                    value={transactionId}
                    onChange={(e) => settransactionId(e.target.value)}
                    onKeyDown={handleKeyDown}
                  ></input>
                </div>
                <div className=" button">
                  <button
                    className="userlist_btn"
                    onClick={() => transactionData("search")}
                    style={{ width: "100px" }}
                  >
                    Search
                  </button>
                </div>
                <div className="button">
                  <button
                    className="refresh-btn"
                    style={{ width: "60px" }}
                    onClick={() => transactionData("refresh")}
                  >
                    <i className="fa fa-refresh"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FilterWrapper>
      </div>

      {transactions && (
        <div className="table-loader">
           {loading && <LocalLoader className="tableLoader" />}
          <TableWrapper pper className="table-card-wrapper">
           
            <table className="table">
              <thead>
                <tr>
                  <th>Reatiler Name</th>
                  <th>Reatiler No.</th>
                 {!travelService.includes(selectOperator) &&  <th>
                    {selectOperator === "PREPAID_RECHARGE"
                      ? "Recharge Number"
                      : selectOperator === "AEPS" || selectOperator === "BBPS"
                      ? "Account Number"
                      : "Account Holder Name"}
                  </th>}
                  {(selectOperator === "SEND_MONEY" || selectOperator === "PAY_OUT") && <th>Account Number </th>}
                  {(selectOperator === "SEND_MONEY" || selectOperator === "PAY_OUT") && <th>Account IFSC Code </th>}
                  {(selectOperator === "CDM") && <th>Card Number  </th>}

                  {selectOperator !== "AEPS" || selectOperator === "BBPS" && (
                    <th>
                      {selectOperator === "PREPAID_RECHARGE"
                        ? "Operator Code"
                        : selectOperator === "DTH"
                        ? "Operator Code"
                        : selectOperator === "AEPS"
                        ? "Order Id"
                        : "Account IFSC Code"}
                    </th>
                  )}
                  <th>Ref. TransactionId</th>
                  <th>
                    {
                      selectOperator === "AEPS"
                        ? "Merchant Transaction Id"
                        : "Transaction Id"
                      // selectOperator === "DTH"
                      // ? "Transaction Id"
                      // : selectOperator === "AEPS"
                      // ? "Merchant Transaction Id"
                      // : selectOperator === "SEND_MONEY"
                      // ? "Transaction Id"
                      // : selectOperator === "PAY_OUT"
                      // ? "Transaction Id"
                      // : "Account IFSC Code"
                    }
                  </th>

                  <th>Date and Time</th>
                  <th>Amount</th>
                  { selectOperator === "AEPS" &&(
                    <>
                    <th>Customer Mobile</th>
                    <th>Customer Aadhaar</th>
                    <th>Customer Balance</th>
                    </>
                  ) }
                    {
                    selectOperator === "POS" &&<>
                    <th>Card Brand</th>
                    <th>Commission</th>
                    <th>Settlement Amount</th>
                    <th>Settlement Status</th>
                    </>
                  }
                  <th>Status</th>
                
                  {!travelService.includes(selectOperator) &&
                  <th>Service Type</th>
                  }
                  
                  <th>{travelService.includes(selectOperator)?"Service Type":"Route"}</th>
                 {selectOperator === "PAY_OUT"  && (((user?.userName === "8800578866") || (user?.userName === "9119917774"))) &&<th>Quick pay</th>}
                 {  selectOperator === "POS" && user?.userType === "ROLE_ADMIN" && <th>Settlement</th>}
                  <th>Action</th>
               
                </tr>
              </thead>
              <tbody>
                {transactions &&
                  transactions?.map((item) => {
                    const dateTimeString = item.transactionDate;
                    let [date, time] = dateTimeString.split("T");
                    let newTime = time.slice(0, 8);
                    return (
                      <tr key={Math.random() * 1000000}>
                        <td>
                          <span className="card-th">Retailer Name</span>
                          <span>{item?.userFullName}</span>
                        </td>
                        <td>
                          <span className="card-th">Retailer No.</span>
                          <span>{item?.userPhoneNumber}</span>
                        </td>
                        {!travelService.includes(selectOperator) && <td>
                          <span className="card-th">
                            {selectOperator === "PREPAID_RECHARGE"
                              ? "Recharge Number"
                              : selectOperator === "AEPS" || selectOperator === "BBPS"
                              ? "Account Number"
                              : "Account Holder Name"}
                          </span>
                          <span>
                            {selectOperator === "PREPAID_RECHARGE"
                              ? item.rechargedNumber
                              : selectOperator === "DTH"
                              ? item.rechargedNumber
                              : selectOperator === "AEPS" || selectOperator ==="BBPS"
                              ? item.accountNumber
                              : item.accountHolderName}
                          </span>
                        </td>}
                        {(selectOperator === "SEND_MONEY" ||  selectOperator === "PAY_OUT") && (
                          <td>
                            <span className="card-th">Account Number</span>
                            <span>{item.accountNumber}</span>
                          </td>
                        )}
                        {(selectOperator === "SEND_MONEY" || selectOperator === "PAY_OUT") && (
                          <td>
                            <span className="card-th">Account IFSC Code</span>
                            <span>{item.accountIfscCode}</span>
                          </td>
                        )}
                        {(selectOperator === "CDM") && (
                          <td>
                            <span className="card-th">Card Number</span>
                            <span>{item.cardNumber}</span>
                          </td>
                        )}
                        {selectOperator !== "AEPS" || selectOperator === "BBPS" &&  (
                          <td>
                            <span className="card-th">
                              {selectOperator === "PREPAID_RECHARGE"
                                ? "Operator Code"
                                : selectOperator === "DTH"
                                ? "Operator Code"
                                : selectOperator === "AEPS"
                                ? "Order Id"
                                : "Account IFSC Code"}
                            </span>
                            <span>
                              {selectOperator === "PREPAID_RECHARGE"
                                ? item.operatorCode
                                : selectOperator === "DTH"
                                ? item.operatorCode
                                : item.accountIfscCode}
                            </span>
                          </td>
                        )}
                        <td>
                          <span className="card-th">Ref. TransactionId</span>
                          <span>{item?.refTransactionId || "-"}</span>
                        </td>

                        <td>
                          <span className="card-th">
                            {selectOperator === "PREPAID_RECHARGE"
                              ? "Transaction Id"
                              : selectOperator === "DTH"
                              ? "Transaction Id"
                              : selectOperator === "AEPS"
                              ? "Merchant Transaction Id"
                              : selectOperator === "SEND_MONEY"
                              ? "Transaction Id"
                              : "Account IFSC Code"}
                          </span>
                          <span>{item?.transactionId || "-"}</span>
                        </td>
                        <td>
                          <span className="card-th">Created Date</span>
                          <span>{date + " " + newTime}</span>
                        </td>
                        <td>
                          <span className="card-th">Amount</span>
                          <span>₹ {item.amount}</span>{" "}
                        </td>
                        { selectOperator === "AEPS" &&(
                    <>
                    <td>
                    <span className="card-th">Customer Mobile</span>
                    <span>{item?.customerMobile || "-"}</span>
                      </td>
                    <td>
                    <span className="card-th">Customer Aadhaar </span>
                    <span>{item?.aadhaar || "-"}</span>
                      </td>
                    <td>
                    <span className="card-th">Customer Balance</span>
                    <span>{item?.bankAccountBalance || "-"}</span>
                      </td>
                  
                 
                    </>
                  )}

                              {
                    selectOperator === "POS" &&<>
                    <td>
                      <span className="card-th">Card Brand</span>
                         <span>{item?.cardBrand || "-"}</span>
                    </td>
                    <td>
                      <span className="card-th">Commission</span>
                         <span>₹ {item?.commission || "-"}</span>
                    </td>
                    <td>
                      <span className="card-th">Settlement Amount</span>
                         <span>₹ {item?.settlementAmount || "-"}</span>
                    </td>
                     <td>
                          <span className="card-th">Settlement Status</span>
                  <span>
                       <div className={` user_action_btn ${item?.isSettlementComplete
                            ? "active_status"
                            : "inactive_status"
                            }`}>{item?.isSettlementComplete ? "Completed" : "Pending"}

                     </div>
                </span>

                    </td>
                
                    
                  
                    </>
                  }
                        <td>
                          <span className="card-th">Status</span>
                          <span>
                            <div
                            className={` user_action_btn ${item.status == "SUCCESS"
                            ? "active_status"
                            : "inactive_status"
                            }`}
                              
                            >
                              {item.status ==="INITIATED" ? "INITIATED":item?.status}
                             {(item.status ==="PENDING") && (selectOperator === "UPI_PAY") && <span><button 
                             style={{marginLeft:"4px"}}
                             onClick={() =>{checkStatus(item?.transactionId)}}>
                             <i className="fa-solid fa-arrows-rotate"></i>
                            </button>
                            </span>}
                            </div>
                          </span>
                        </td>
                
                         {
                 
                  }
                        {!travelService.includes(selectOperator) &&
                  <td>
                  <span className="card-th">Service Type</span>
                  <span>{item?.serviceType}</span>
                </td>
                  }
                        
                        <td>
                          <span className="card-th">{travelService.includes(selectOperator)?"Service Type":"Route"}</span>
                          <span>{item?.route}</span>
                        </td>
                        {selectOperator === "PAY_OUT"  && (((user?.userName === "8800578866") || (user?.userName === "9119917774"))) &&<td>
                          <span className="card-th">Quick pay</span>
                          <span>
                          <span  onClick={() => handlePayout(item)} class="flex item-center payment-btn"><span>₹</span>Quick Pay</span>
                          
                          </span>
                          </td>}
                      
                       { selectOperator === "POS" && user?.userType === "ROLE_ADMIN" && <td className="user_action_btn ">
                              <span className="card-th">Settlement</span>
                              <span>
                                {!item?.isSettlementComplete?
                            <button style={{height:"24px", width:"40px",color:"#00baf2"}}
                            onClick={()=>setSettlement(item)}
                            >
                               <i className="fa fa-wallet"></i>
                            </button>
                                :"-"}
                                
                              </span>
                            </td>}
                          <td className="user_action_btn button">
                              <span className="card-th">Action</span>
                              <span>
                                <MoreOptions options={moreOptions} items={item} />
                              </span>
                            </td>  
                      </tr>
                    );
                  })}

                {!loading && transactions && transactions.length < 1 && (
                  <>
                    <tr>
                      <td
                        colSpan={12}
                        style={{
                          color: "red",
                          textAlign: "center",
                          height: "140px",
                        }}
                      >
                        No Data Found
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </TableWrapper>
        </div>
      )}

{!isEmpty(checkStatusMsg) && (
       <AlertWrapper className={`${checkStatusMsg.type} globle`}>
       <span className="close" onClick={() => setCheckStatusMsg({})}>
         ×
       </span>
       {checkStatusMsg.msg}
     </AlertWrapper>
      )}

     
{/* { payBox && <AsideLeft  close = {()=>closeSidebar()} refresh={transactionData} payoutData={payoutData} userName={user?.userName} />}
{ settlement && <AsideLeft  close = {()=>{
    setSettlement(null);
     setSelectOperator("POS")
}

  } refresh={transactionData} payoutData={{}} userName={user?.userName} type="settlement" settlementData={settlement} />} */}
{ payBox && <AsideLeft_V2  close = {()=>closeSidebar()} refresh={transactionData} payoutData={payoutData} userName={user?.userName} />}
{ settlement && <AsideLeft_V2  close = {()=>{
    setSettlement(null);
     setSelectOperator("POS")
}

  } refresh={transactionData} payoutData={{}} userName={user?.userName} type="settlement" settlementData={settlement} />}
      {totalPages > 1 && (
        <Pagination
          items={transactions}
          itemsPerPage={pageSize}
          setitemsPerPage={setPageSize}
          currentPage={currPage}
          setcurrentPage={setCurrPage}
          totalPages={totalPages}
          forcePage={currPage}
        />
      )}
    </div>
    {refundData && <ConfirmBox cancel={()=>setRefundData(null)} ok={() => RefundTransaction(refundData)}>
                     <label>You want to refund this transaction?</label>
                     </ConfirmBox>}
    </div>

  );
};

export default TransactionTable;
